import { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { updateContrasena } from "../../../redux/actions";
import SuccessModal from "../../../components/modals/successModal";
import ErrorModal from "../../../components/modals/errorModal";
import { EyeIcon, EyeOffIcon } from "../../../components/icons/SvgIcons";
import Button from "../../../components/button";

function ResetearUsuarioComponent({
  userId,
  onClose,
  onActualizacion,
}) {
  const dispatch = useDispatch();

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isPasswordVisible2, setIsPasswordVisible2] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();


  const contrasena = watch("contrasena");

  const onSubmit = async (data) => {
    const finalData = {
      ...data,
      id: userId,
    };

    setLoading(true);

    try {
      await dispatch(updateContrasena(finalData));
      setShowSuccessModal(true);
    } catch (error) {
      console.error("Error al cambiar la contraseña:", error);
      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  };

  const closeSuccessModal = () => {
    setShowSuccessModal(false);

    if (typeof onActualizacion === "function") {
      onActualizacion();
    }

    onClose();
  };

  const closeErrorModal = () => {
    setShowErrorModal(false);
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      onClick={onClose}
    >
      <div
        className="w-[20rem] bg-white p-6 rounded-lg shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="text-2xl font-bold mb-4 text-center">
          Cambiar contraseña
        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Nueva contraseña
            </label>

            <div className="relative">
              <input
                type={isPasswordVisible ? "text" : "password"}
                placeholder="Contraseña"
                disabled={loading}
                className="w-full text-sm font-normal font-inter outline-none rounded-md py-2 pr-10"
                {...register("contrasena", {
                  required: "La contraseña es obligatoria",
                  minLength: {
                    value: 7,
                    message: "La contraseña debe tener más de 6 caracteres",
                  },
                  maxLength: {
                    value: 15,
                    message:
                      "La contraseña no debe exceder los 15 caracteres",
                  },
                })}
              />

              <button
                type="button"
                disabled={loading}
                onClick={() =>
                  setIsPasswordVisible(!isPasswordVisible)
                }
                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
              >
                {isPasswordVisible ? (
                  <EyeOffIcon className="w-5 h-5" />
                ) : (
                  <EyeIcon className="size-6" />
                )}
              </button>
            </div>

            <label className="block text-sm font-medium text-gray-700 my-2">
              Repita la contraseña
            </label>

            <div className="relative">
              <input
                type={isPasswordVisible2 ? "text" : "password"}
                placeholder="Contraseña"
                disabled={loading}
                className="w-full text-sm font-normal font-inter outline-none rounded-md pl-4 pr-10 py-2"
                {...register("contrasena2", {
                  required: "Confirme la contraseña por favor",
                  validate: (value) =>
                    value === contrasena ||
                    "Las contraseñas no coinciden",
                })}
              />

              <button
                type="button"
                disabled={loading}
                onClick={() =>
                  setIsPasswordVisible2(!isPasswordVisible2)
                }
                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
              >
                {isPasswordVisible2 ? (
                  <EyeOffIcon className="w-5 h-5" />
                ) : (
                  <EyeIcon className="size-6" />
                )}
              </button>
            </div>
          </div>

          <div className="flex flex-col justify-center gap-4">
            <Button type="submit" fullWidth loading={loading}>
              Guardar
            </Button>

            <Button
              type="button"
              variant="secondary"
              fullWidth
              disabled={loading}
              onClick={onClose}
            >
              Cancelar
            </Button>
          </div>
        </form>

        <div className="gap-0 mt-[1rem] mb-[1rem] justify-center items-center text-center">
          {Object.values(errors).map((error, index) => (
            <p className="text-red-500" key={index}>
              {error.message}
            </p>
          ))}
        </div>
      </div>

      {showSuccessModal && (
        <SuccessModal
          closeSuccessModal={closeSuccessModal}
          message="Contraseña cambiada con éxito."
        />
      )}

      {showErrorModal && (
        <ErrorModal
          closeErrorModal={closeErrorModal}
          message="Hubo un error al cambiar la contraseña."
        />
      )}
    </div>
  );
}

export default ResetearUsuarioComponent;